import { render, staticRenderFns } from "./ElementFormText.vue?vue&type=template&id=3e2b306b&"
import script from "./ElementFormText.vue?vue&type=script&lang=js&"
export * from "./ElementFormText.vue?vue&type=script&lang=js&"
import style0 from "./ElementFormText.vue?vue&type=style&index=0&id=3e2b306b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports